export default __webpack_public_path__ + "static/media/114.06988f96.jpg";